import { z } from 'zod';
// TODO: Use common country codes as identifiers
export const I18nStringSchema = z.object({
    english: z.string(),
    spanish: z.string()
});
//# sourceMappingURL=i18n.js.map